import { render, staticRenderFns } from "./adminHome.vue?vue&type=template&id=6c942213&scoped=true"
import script from "./adminHome.vue?vue&type=script&lang=js"
export * from "./adminHome.vue?vue&type=script&lang=js"
import style0 from "./adminHome.vue?vue&type=style&index=0&id=6c942213&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c942213",
  null
  
)

export default component.exports